import { render, staticRenderFns } from "./screening-images.vue?vue&type=template&id=954742ac&scoped=true&"
import script from "./screening-images.vue?vue&type=script&lang=js&"
export * from "./screening-images.vue?vue&type=script&lang=js&"
import style0 from "./screening-images.vue?vue&type=style&index=0&id=954742ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954742ac",
  null
  
)

export default component.exports